
import * as Project from "./projectStyles";

import { FaGithub, FaExternalLinkAlt } from "react-icons/fa"


export default function ProjectItemTwo({ project }){
    return (
        <>
            <Project.ItemContainer data-aos="fade-up">
                <Project.InfoContainerTwo>
                    <Project.FeaturedText>Feature Project</Project.FeaturedText>
                    <Project.ItemName>{project.title}</Project.ItemName>
                    <Project.DescriptionContainer>
                        <Project.DescriptionText>{project.description}</Project.DescriptionText>
                    </Project.DescriptionContainer>
                    <Project.TechnologiesContainerTwo>
                        {
                            project.technologies &&
                            project.technologies.map(
                                (item, index) =><Project.TechnologiesTextTwo key={index}>{item}</Project.TechnologiesTextTwo>
                            )
                        }
                    </Project.TechnologiesContainerTwo>
                    <Project.LinksContainer>
                        <Project.LinkTwo href={project.github} target="_blank"><FaGithub/></Project.LinkTwo>
                        {
                            project.website ? 
                            <Project.LinkTwo href={project.website} target="_blank"><FaExternalLinkAlt/></Project.LinkTwo> : 
                            null
                        }
                    </Project.LinksContainer>
                </Project.InfoContainerTwo>
                <Project.ItemSnapshotContainer>
                    <Project.ItemSnapshot src={project.photoUrl} />
                </Project.ItemSnapshotContainer>


            </Project.ItemContainer>
        </>

    )
}